







































































import { Vue, Component, Prop } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class BulkUnsubscriptionForm extends Vue {
    @Prop({ required: true }) uploadFromFile!: {
        active: false;
        mode: string;
        valid: false;
        uploadfile: undefined;
        bulkUnsubscriptionDescription: string;
        bulkUnsubscriptionTotalSubscription: number | null;
        userId: number;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() statementEdit!: any;
    @Prop() chipFile!: boolean;

    chip = false;
    menu = false;
    loading = false;
    providers = [];
    fileUploaded = false;

    close () {
        this.$emit('closeModal')
    }

    getMonthNow () {
        return moment()
            .format('YYYY-MM')
            .toString()
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    validate () {
        return (this.$refs.form as Vue & {
            validate: () => boolean;
        }).validate()
    }

    save () {
        if (this.validate()) {
            if (this.uploadFromFile.mode === 'Edit') {
                this.editBulkUnsubscription()
            } else {
                this.createBulkUnsubscription()
            }
        }
    }

    uploadFile () {
        this.loading = true
        this.$store
            .dispatch('createBulkUnsubscriptionPending', {
                uploadfile: this.uploadFromFile.uploadfile
            })
            .then(resp => {
                if (resp.status === 200) {
                    this.uploadFromFile.bulkUnsubscriptionTotalSubscription = resp.data.subscriptions
                    this.fileUploaded = true
                } else {
                    this.$store.commit('reportError', 'File NOT save.')
                }
                this.loading = false
            })
    }

    createBulkUnsubscription () {
        this.loading = true
        this.uploadFromFile.userId = this.userData.userId
        this.$store
            .dispatch('createBulkUnsubscription', this.uploadFromFile)
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'Bulk unsubscription not save.')
                }
                this.loading = false
            })
    }

    editBulkUnsubscription () {
        this.loading = true
        this.$store
            .dispatch('editBulkUnsubscription', {
                id: this.statementEdit.bulkUnsubscriptionId,
                params: this.uploadFromFile
            })
            .then((resp: { status: number }) => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'File NOT save.')
                }
                this.loading = false
            })
    }

    async mounted () {
        this.uploadFromFile.bulkUnsubscriptionTotalSubscription = null
        this.fileUploaded = false
    }
}
